export const TableHeader = (t) => ([
  {
    title: t("labels.country.basicInformation.countryTable.headers.name"),
    field: "name",
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.iso2"),
    field: "iso_code_2",
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.iso3"),
    field: "iso_code_3",
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.supportsMDM"),
    field: "supports_mdm",
    render: (rowData) => {
      return !rowData.supports_mdm ? "No" : "Yes";
    },
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.jllCovered"),
    field: "jll_covered",
    render: (rowData) => {
      return rowData.jll_covered === "0" ? "No" : "Yes"
    },
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.isIllegal"),
    field: "illegal",
    render: (rowData) => {
      return !rowData.illegal ? "No" : "Yes";
    },
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.mlroContact"),
    render: (rowData) => {
      return rowData.mlro_contact_names ? `${rowData.mlro_contact_names}(${rowData.mlro_contact_emails})` : "-";
    },
  },
  {
    title: t("labels.country.basicInformation.countryTable.headers.mlroDelegate"),
    render: (rowData) => {
      return rowData.mlro_delegate_names ? `${rowData.mlro_delegate_names}(${rowData.mlro_delegate_emails})` : "-";
    },
  },
]);
